import React from 'react';
import { MapPin, Phone, Mail, Users, Clock } from 'lucide-react';
import { Card, CardContent } from "../components/ui/card";

export default function Contact() {
  return (
    <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <h1 className="text-3xl font-bold text-slate-800 border-b pb-4">Contact și Audiențe</h1>

      {/* Date principale de contact */}
      <div className="grid md:grid-cols-2 gap-6">
        <Card className="bg-blue-600 text-white shadow-md border-none">
          <CardContent className="p-6 space-y-4">
            <h3 className="font-semibold text-xl mb-4 text-yellow-400 border-b border-blue-500 pb-2">Serviciul Public Comunitar</h3>
            
            <div className="flex items-start gap-3">
              <MapPin className="w-5 h-5 text-blue-300 flex-shrink-0 mt-1" />
              <div>
                <p className="font-medium">Adresa:</p>
                <p className="text-blue-100 text-sm leading-relaxed">Târgu Jiu, str. Victoriei, nr. 4<br/>Județul Gorj, Cod 210165</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <Phone className="w-5 h-5 text-blue-300 flex-shrink-0 mt-1" />
              <div>
                <p className="font-medium">Telefon / Fax:</p>
                <p className="text-blue-100 text-sm">0253.222.033</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <Mail className="w-5 h-5 text-blue-300 flex-shrink-0 mt-1" />
              <div>
                <p className="font-medium">E-mail General:</p>
                <a href="mailto:office@srpcivgorj.ro" className="text-yellow-400 hover:text-yellow-300 text-sm underline">office@srpcivgorj.ro</a>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Contacte Specifice */}
        <Card className="shadow-sm border-slate-200">
          <CardContent className="p-6">
            <h3 className="font-semibold text-lg mb-4 text-slate-800 flex items-center gap-2">
              <Users className="w-5 h-5 text-blue-600" />
              Adrese de e-mail directe
            </h3>
            
            <div className="space-y-4 text-sm">
              <div className="pb-3 border-b border-slate-100">
                <p className="font-semibold text-slate-700">Șef serviciu - Dinolu Nicolae</p>
                <a href="mailto:nicolae.dinolu@srpcivgorj.ro" className="text-blue-600 hover:underline">nicolae.dinolu@srpcivgorj.ro</a>
              </div>
              
              <div className="pb-3 border-b border-slate-100">
                <p className="font-semibold text-slate-700">Coordonator compartiment permise și examinări - Jugravu Adrian</p>
                <a href="mailto:adrian.jugravu@srpcivgorj.ro" className="text-blue-600 hover:underline">adrian.jugravu@srpcivgorj.ro</a>
              </div>

              <div className="pb-3 border-b border-slate-100">
                <p className="font-semibold text-slate-700">Coordonator compartiment înmatriculări - Pomaga Valentin</p>
                <a href="mailto:valentin.pomaga@srpcivgorj.ro" className="text-blue-600 hover:underline">valentin.pomaga@srpcivgorj.ro</a>
              </div>

              <div>
                <p className="font-semibold text-slate-700">Coordonator compartiment informatică - Ciora Florin</p>
                <a href="mailto:florin.ciora@srpcivgorj.ro" className="text-blue-600 hover:underline">florin.ciora@srpcivgorj.ro</a>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Program Audiente */}
      <h2 className="text-2xl font-bold text-slate-800 mt-10 mb-6 flex items-center gap-2">
        <Clock className="w-6 h-6 text-blue-600" />
        Program de Audiență
      </h2>

      <div className="grid md:grid-cols-3 gap-4">
        <Card className="bg-slate-50 border-slate-200">
          <CardContent className="p-5">
            <h4 className="font-bold text-blue-900 mb-1">Șeful Serviciului</h4>
            <p className="text-xs text-slate-500 mb-3 font-medium">Comisar șef de poliție<br/>Dinolu Nicolae</p>
            <div className="space-y-1 text-sm text-slate-700">
              <div className="flex justify-between"><span>Marți:</span> <span className="font-bold">12:00 - 14:00</span></div>
              <div className="flex justify-between"><span>Joi:</span> <span className="font-bold">10:00 - 12:00</span></div>
            </div>
          </CardContent>
        </Card>

        <Card className="bg-slate-50 border-slate-200">
          <CardContent className="p-5">
            <h4 className="font-bold text-blue-900 mb-1">Permise și Examinări</h4>
            <p className="text-xs text-slate-500 mb-3 font-medium">Subcomisar de poliție<br/>Jugravu Adrian</p>
            <div className="space-y-1 text-sm text-slate-700">
              <div className="flex justify-between"><span>Luni:</span> <span className="font-bold">14:00 - 16:00</span></div>
              <div className="flex justify-between"><span>Vineri:</span> <span className="font-bold">10:00 - 12:00</span></div>
            </div>
          </CardContent>
        </Card>

        <Card className="bg-slate-50 border-slate-200">
          <CardContent className="p-5">
            <h4 className="font-bold text-blue-900 mb-1">Înmatriculări și Evidență</h4>
            <p className="text-xs text-slate-500 mb-3 font-medium">Comisar șef de poliție<br/>Pomaga Valentin</p>
            <div className="space-y-1 text-sm text-slate-700">
              <div className="flex justify-between"><span>Vineri:</span> <span className="font-bold">12:00 - 14:00</span></div>
            </div>
          </CardContent>
        </Card>
      </div>

    </div>
  );
}
